import wixFullstoryLoader from '@wix/wix-fullstory-loader';

import renderApp from './client/renderApp';

import { feedClient } from './lib/services';

import { biLogger } from './client/bi';
import getTPABIContext from './lib/bi/getTPABIContext';

import { IInitialAppData } from './types/types';

const appData: IInitialAppData = window.__APP_DATA__;

wixFullstoryLoader({ label: 'podcasts-widget' });
feedClient.init({ endpoint: appData.context.config.services.feed });

biLogger.updateDefaults({
  ...getTPABIContext(appData.context.tpa),
  artifactVersion: appData.artifactVersion,
});

renderApp(appData).catch((error) => {
  console.error(error);
});
